export var DifficultyFilter;
(function (DifficultyFilter) {
    DifficultyFilter["ALL"] = "all";
    DifficultyFilter["EXTREMES"] = "extremes";
    DifficultyFilter["NON_EXTREMES"] = "noExtremes";
})(DifficultyFilter || (DifficultyFilter = {}));
export var PlatformerFilter;
(function (PlatformerFilter) {
    PlatformerFilter["ALL"] = "all";
    PlatformerFilter["PLATFORMER"] = "platformer";
    PlatformerFilter["CLASSIC"] = "classic";
})(PlatformerFilter || (PlatformerFilter = {}));
export var ProgressFilter;
(function (ProgressFilter) {
    ProgressFilter["ALL"] = "all";
    ProgressFilter["COMPLETED"] = "completed";
    ProgressFilter["IN_PROGRESS"] = "inProgress";
})(ProgressFilter || (ProgressFilter = {}));
export var ProofFilter;
(function (ProofFilter) {
    ProofFilter["ALL"] = "all";
    ProofFilter["HAS_PROOF"] = "hasProof";
    ProofFilter["NO_PROOF"] = "noProof";
})(ProofFilter || (ProofFilter = {}));
